<div style="position: relative" [id]="idPrefix + '-container'">
  <mat-form-field appearance="outline" floatLabel="always" [class.selected]="isSelected" [id]="idPrefix + '-input'">
    <mat-label [id]="idPrefix + '-label'" >{{label}}</mat-label>
    @if (options$ | async; as selectOptions) {
      <mat-select disableOptionCentering="true" hideSingleSelectionIndicator="true" [attr.aria-owns]="getOptionAriaId()" [formControl]="formControl"
        [multiple]="multiple" [panelClass]="dropdownClass" [placeholder]="display" (openedChange)="onOpenedChange($event)"
        (selectionChange)="onSelectionChanged(selectOptions)">
        <mat-select-trigger>
          @if (!displayTemplate) {
            {{ display }}
          } @else {
            <ng-template [ngTemplateOutlet]="displayTemplate" />
          }
        </mat-select-trigger>
        @if (displayOptions?.display) {
          <mat-option class="header-option" disabled id="disabled-option">
            <!-- This is a hack to get the menu option list to display a header-->
            {{displayOptions.display}}
          </mat-option>
        }
        @for (option of selectOptions; track option) {
          <mat-option [id]="getOptionId(option)" [value]="valuePath ? option[valuePath] : option">
            @if (optionTemplate == null) {
              <span class="option-title">
                {{ displayPath ? option[displayPath] : option }}
              </span>
            } @else {
              <template [ngTemplateOutlet]="displayDateRangeTemplate || optionTemplate" [ngTemplateOutletContext]="{item: option}"></template>
            }
          </mat-option>
        }
      </mat-select>
    }

    @if (isSelected && deselectAllEnabled) {
      <mat-icon class="clear-button" matSuffix (click)="clear($event)">
        close
      </mat-icon>
    }

    @if (hint) {
      <mat-hint [id]="idPrefix + '-hint'">{{hint}}</mat-hint>
    }
    @if (formControl && formControl.invalid) {
      <mat-error [id]="idPrefix + '-error'" [innerHTML]="errors" />
    }
  </mat-form-field>
</div>
